$mol_icon_rectangle $mol_icon path \M4,6V19H20V6H4Z
